<template>
  <div class="charts">
    <div class="row">
      <div class="col-12">
        <GChart
          type="SteppedAreaChart"
          :data="chartData"
          :options="chartOptions"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <GChart
          type="PieChart"
          :data="pieData"
          :options="pieOptions"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SquareLoader from '../SquareLoader';

export default {
  name: 'ProfileCharts',
  components: { SquareLoader },
  props: {
    games: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      chartData: [
        ['Jeux', 'Joueur', { type: 'string', role: 'tooltip' }],
        ...this.games.map(game => [this.convertDate(game.createdAt), (game.score / game.totalTop) * 100, `${((game.score / game.totalTop) * 100).toFixed(2)}%`]),
      ],
      chartOptions: {
        title: 'Votre score par rapport au top',
        subtitle: '',
        vAxis: {
          title: 'Nombre de points',
          minValue: 0,
          maxValue: 100,
        },
        height: 400,
        backgroundColor: 'transparent',
      },
      pieData: [
        ['Score', 'Nb de parties'],
        ['> 95% du top', this.nbGamesWithPercentIn(95, 100)],
        ['entre 90% et 95% du top', this.nbGamesWithPercentIn(90, 95)],
        ['entre 85% et 90% du top', this.nbGamesWithPercentIn(85, 90)],
        ['entre 80% et 85% du top', this.nbGamesWithPercentIn(80, 85)],
        ['entre 70% et 80% du top', this.nbGamesWithPercentIn(70, 80)],
        ['entre 60% et 70% du top', this.nbGamesWithPercentIn(60, 70)],
        ['< 60% du top', this.nbGamesWithPercentIn(0, 60)],
      ],
      pieOptions: {
        title: 'Répartition du nombre de parties en % du top',
        is3D: true,
        height: 400,
        backgroundColor: 'transparent',
      },
    };
  },
  methods: {
    convertDate(timestamp) {
      const d = new Date(timestamp);
      return `${d.toLocaleDateString()}`;
    },
    nbGamesWithPercentIn(from, to) {
      return this.games
        .filter(game => game.score >= (game.totalTop * (from / 100))
          && game.score < (game.totalTop * (to / 100)))
        .length;
    },
  },
};
</script>

<style scoped>
.charts {
  min-height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/ProfileCharts.vue